import React from "react";
import { Icon } from "../../../_components";

export function TimelineBasics() {
  return (
    <div className="chronos-help-topic-page chronos-timeline-basics-topic">
      <p>
        A Timeline is a linear display of Events, mapped out over time.
        Timelines are shown in the bottom part of your screen (beneath the map).
        They extend from the past (left) to the future (right).
      </p>
      <p>
        A Timeline will remain visible, even if Events don't show in the current
        visible span of time.
      </p>
      <h3 className="chronos-topic-header">Current Position Line</h3>
      <p>
        The red vertical line in the center of your timelines shows your current
        position in time. Drag the timeline from side to side with your mouse to
        change the current position. You can jump to another place in your
        timeline using the "Go to" box at the bottom right.
      </p>
      <h3 className="chronos-topic-header">
        Granularity &amp; Default Time Unit
      </h3>
      <p>
        By default, your timeline displays in a Granularity of years. This means
        each of the small gradations along the bottom of your timeline is one
        year. You can change the Granularity of your timeline in the
        bottom-right corner.
        <br />
        To change which Default Time Unit is displayed on initialization, go to{" "}
        <Icon icon="fas fa-cogs fa-fw" /> Chronicle Settings{" "}
        <Icon icon="fas fa-chevron-right fa-fw" /> Time &amp; Date tab
      </p>
      <h3 className="chronos-topic-header">Navigation</h3>
      <p>
        In Chronicles, your timelines can extend "infinitely" (within reason!)
        into the past and future! To help performance, Timelines are therefore
        set up to view "pages" - sections of your timeline. There are navigation
        arrows at either end of the Timeline to go to the previous or next
        "page". To adjust how big these "pages" are, go to{" "}
        <Icon icon="fas fa-cogs fa-fw" /> Chronicle Settings{" "}
        <Icon icon="fas fa-chevron-right fa-fw" /> Time &amp; Date tab{" "}
        <Icon icon="fas fa-chevron-right fa-fw" /> Number of Years to Display on
        Timeline.
        <br />
        You can set this to a maximum of 1000 units.
      </p>
      <h3 className="chronos-topic-header">Event Lanes</h3>
      <p>
        Timelines are split into four Event Lanes. You can specify which lane
        your event is on when you create or edit an Event.
      </p>
      <p>
        Use Event Lanes to distinguish events that happen simultaneously, or
        close together, on one timeline. When zoomed out in time (i.e. when the
        Granularity is lowered), Events which are close together are "bundled"
        to show a circle with a number inside. By moving an Event to a different
        Event Lane, you can ensure the Event will be displayed distinctly.
      </p>
      <h3 className="chronos-topic-header">Using Multiple Timelines</h3>
      <p>
        While you can have multiple timelines, most Chronicles projects will
        probably only need one, or at most, two or three. Each additional
        Timeline can potentially affect performance for your viewers,
        particularly if you have hundreds of events! Use fewer Timelines when
        possible to help minimize this.
      </p>
      <p>
        If you have more than two timelines, use either your mouse wheel or the
        arrow buttons on the bottom right to scroll through them.
      </p>
    </div>
  );
}
